var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-warning",
  "use": "ring-icon-warning-usage",
  "viewBox": "0 0 19 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 16\" id=\"ring-icon-warning\"><path d=\"M18.64 14L10.49.54a1.14 1.14 0 0 0-1.94 0L.35 14.06C-.1 14.79.27 16 1.14 16H17.9c.87 0 1.19-1.29.74-2zM9.38 3a1.53 1.53 0 0 1 1.72 1.54c0 .19 0 .78-.06.82l-.35 4.69a1.17 1.17 0 0 1-1.28 1 1.14 1.14 0 0 1-1.1-1l-.42-5.48A1.46 1.46 0 0 1 9.38 3zm.15 11.71a1.37 1.37 0 1 1 1.36-1.37 1.37 1.37 0 0 1-1.36 1.37z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id